import Button from '@components/buttons/Button';
import { Logo } from '@components/elements/Logo';
import { useAuth } from '@contexts/auth';
import { socialLinks } from '@utils/agoraLinks';
import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';

const MobileMenu = ({ isToggled, handleToggle }) => {
  const { session, logOut } = useAuth();
  return (
    <div
      className={clsx('relative z-[999] transition duration-300', {
        block: isToggled,
        hidden: !isToggled
      })}
    >
      <div className="fixed inset-0 bg-[#0b1324]/30 fade-in" onClick={handleToggle} />
      <nav
        aria-label="Menú móvil"
        className={clsx(
          'fixed top-0 left-0 bottom-0 flex flex-col w-5/6 max-w-sm py-6 px-6 glass-mobile-menu border-r border-gray-100 overflow-y-auto',
          { 'h-screen mobile-menu-panel': isToggled }
        )}
      >
        <div className="flex items-center mb-8 justify-between">
          <Link href="/" className="logo">
            <Logo type="horizontal" width="50%" color={'#212121'} />
          </Link>
          <button aria-label="Cerrar menú" className="navbar-close w-9 h-9 flex items-center justify-center rounded-xl glass-button" onClick={handleToggle}>
            <svg
              className="h-5 w-5 text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div>
          <ul className="mobile-menu">
            <li className="mb-1 rounded-xl">
              <Link
                className="block p-3 text-sm text-pgray-500 hover:bg-gray-50 hover:text-primary-500 rounded-xl transition-all duration-200"
                href="/"
                onClick={() => trackEvent(EVENTS.NAV_MOBILE_MENU_LINK_CLICKED, { link_name: 'Principal' })}
              >
                Principal
              </Link>
            </li>
            <li className="mb-1 rounded-xl">
              <Link
                className="block p-3 text-sm text-pgray-500 hover:bg-gray-50 hover:text-primary-500 rounded-xl transition-all duration-200"
                href="/negocios"
                onClick={() => trackEvent(EVENTS.NAV_MOBILE_MENU_LINK_CLICKED, { link_name: 'Negocios' })}
              >
                Negocios
              </Link>
            </li>
            {session && (
              <>
                <li className="mb-1 rounded-xl">
                  <Link
                    className="block p-3 text-sm text-pgray-500 hover:bg-gray-50 hover:text-primary-500 rounded-xl transition-all duration-200"
                    href="/perfil"
                    onClick={() => trackEvent(EVENTS.NAV_MOBILE_MENU_LINK_CLICKED, { link_name: 'Perfil' })}
                  >
                    Perfil
                  </Link>
                </li>
                <li className="mb-1 rounded-xl">
                  <span
                    className="block p-3 text-sm text-pgray-500 hover:bg-gray-50 hover:text-primary-500 rounded-xl transition-all duration-200 cursor-pointer"
                    onClick={() => {
                      trackEvent(EVENTS.NAV_MOBILE_MENU_LINK_CLICKED, { link_name: 'Salir' });
                      logOut();
                    }}
                  >
                    Salir
                  </span>
                </li>
              </>
            )}
          </ul>
          {!session && (
            <div className="mt-4 pt-6 flex flex-col gap-4" style={{ borderTop: '1px solid rgba(0,0,0,0.06)' }}>
              <Button type="outlined" href="/signin">
                Ingresar
              </Button>
              <Button type="secondary" href="/signup">
                Agregá tu negocio
              </Button>
            </div>
          )}
        </div>
        <div className="flex flex-col items-center mt-4 pt-6" style={{ borderTop: '1px solid rgba(0,0,0,0.06)' }}>
          <div className="flex space-x-6">
            {socialLinks.map((link, index) => (
              <Link key={index} target="_blank" rel="noopener noreferrer" href={link.href} className="text-gray-500 hover:text-[#212121] transition-colors" aria-label={link.name} onClick={() => trackEvent(EVENTS.NAV_SOCIAL_LINK_CLICKED, { platform: link.name })}>
                {link.icon}
              </Link>
            ))}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default MobileMenu;
